import React from "react";
import { Box } from '@curves/ui-base';

import { ChangeRecordCard } from "@Local/CyclePurchase/Components/ChangeRecord";
const CyclePurchaseDetailHistoryCard = props => {
	const { memberID, cycleOrderID } = props;
	return (
		<Box className="cycle-purchase-history-timeline">
			<ChangeRecordCard onPreviewPdf={() => {}} extraSection={() => {}} memberID={memberID} cycleOrderID={cycleOrderID} />
		</Box>
	);
};
export default CyclePurchaseDetailHistoryCard;
